module.exports = __webpack_public_path__ + "static/media/tile-4.4a28a382.png";